import React from 'react';
import { Box, Inscription, OrgLockIcon } from '@common-fe/common-fe';

import { LetterIconSizeEnum, OrganizationTypes } from '@/common/constants';
import { Icon } from '@/components/elements/Icon/Icon';

interface Props {
  orgName?: string;
  logoUrl?: string;
  isLocked?: boolean;
  lastUpdatedAt?: string;
  orgType?: OrganizationTypes;
}

const BankingBalanceOrgDetailsHeader: React.FC<Props> = ({
  orgName,
  logoUrl,
  isLocked,
  lastUpdatedAt,
  orgType,
}) => (
  <Box
    data-testid="org-details-header"
    direction="row"
    align="center"
    justify="between"
    margin={{ bottom: 'spacing24' }}
    height="44px"
  >
    {orgName && (
      <Box direction="row" align="center" margin={{ right: 'spacing4' }} gap="spacing12">
        <Icon
          text={orgName}
          type={orgType}
          src={logoUrl}
          size={LetterIconSizeEnum.LOGO}
          width="auto"
        />
        <Inscription color="textTitle" weight="bold" size="2xl">
          {orgName}
        </Inscription>
        {isLocked && (
          <Box direction="row" align="center" gap="spacing4">
            <OrgLockIcon color="danger" size="16px" />
            <Inscription color="danger">Locked</Inscription>
          </Box>
        )}
      </Box>
    )}
    <Box direction="row" gap="spacing2" align="center">
      <Inscription color="textSecondary">
        Last updated on {lastUpdatedAt || '-'}
      </Inscription>
    </Box>
  </Box>
);

export default BankingBalanceOrgDetailsHeader;
